import React, { Component } from 'react';
import { Table, Button, Alert } from 'reactstrap';
import { TabContent, TabPane, Nav, NavItem, NavLink, CardTitle, CardText, Row, Col } from 'reactstrap';
import { Collapse, CardBody, Card, CardHeader, CardFooter, Input, Badge, Media, Text } from 'reactstrap';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { FaEdit, FaPlus, FaTrashAlt } from 'react-icons/fa';
import { withRouter } from 'react-router-dom';
import { AiFillCaretUp, AiFillCaretDown } from 'react-icons/ai';
import history from "../historyBeta";
import './NavMenu.css';
import url from "./variables/url.js";
import Paginacion from './Paginacion';
import ActividadCard from './ActividadCard';
import Vacio from './Vacio';
import { AppContext } from '../AppContext';
import PropTypes from 'prop-types';

/*const localBack = url.localBack;*/
const localBack = process.env.REACT_APP_BACK;
const homepage = process.env.REACT_APP_EXP;

class LoteActividadesPorTipo extends Component {
    static displayName = LoteActividadesPorTipo.name;

    constructor(props) {
        super(props);
        /*const actividadesList = this.props.actividades;*/
        const userId = this.props.userId;
        const categoriaId = this.props.categoria;
        const tipoId = this.props.tipo;
        this.state = {            
            loading: true,                        
            categorias: [],
            tipos: [],
            currentUser: [],
            collapse: 0,
            dropdownOpen: false,
            id: userId,
            categoria: categoriaId,
            tipo: tipoId,
            actividades: [],
            instituciones: [],
            currentActividades: [],
            currentPage: null,
            totalPages: null,
            editable: this.props.editable ?? true,
        };

        this.handleEdit = this.handleEdit.bind(this);
        this.toggle = this.toggle.bind(this);
        this.toggleCard = this.toggleCard.bind(this);
        this.toggleDD = this.toggleDD.bind(this);
        this.newActEst = this.newActEst.bind(this);        
    }

    componentDidMount() {
        let user = this.context;
        this.setState({ currentUser: user });
        /*console.log('user', this.state.currentUser.idpersona);*/
        this.populateInfoData();
        this.populateActividades();
    }

    componentDidUpdate(prevState) {
        //let user = this.context;
        //if (user != null && prevState.actividades.length !== this.state.actividades.length)
        // this.populateActividades();
    }

    onPageChanged = data => {
        const { actividades } = this.state;
        const { currentPage, totalPages, pageLimit } = data;
        const offset = (currentPage - 1) * pageLimit;
        const currentActividades = actividades.slice(offset, offset + pageLimit);

        this.setState({ currentPage, currentActividades, totalPages });
    }    

    renderActividadesTable(actividades, currentActividades, currentPage, totalPages) {
      const currentUser = this.context;
      const { collapse } = this.state;      
      const totalAct = actividades.length;      
      const limite = 6;     
      const vecindario = 1;
      
      return (
      <div>                                     
              {actividades.length == 0 ?
                  <>
                      <Media>                          
                          <Media body>
                              <div className="py-2">
                                  <Vacio editable={this.state.editable} />
                              </div>
                          </Media>
                      </Media>
                  </> :
                  <>
                      <div className="container mb-5" style={{ flex: 2 }}>
                          <div className="row d-flex flex-row">
                              <div className="w-100 px-4 d-flex flex-row flex-wrap align-items-center justify-content-between">
                                  {/*<div className="d-flex flex-row align-items-center">                                      */}
                                  {/*    {currentPage && (*/}
                                  {/*        <span className="current-page d-inline-block h-100 pl-4 text-secondary">*/}
                                  {/*            Pagina <span className="font-weight-bold">{currentPage}</span> / <span className="font-weight-bold">{totalPages}</span>*/}
                                  {/*        </span>*/}
                                  {/*    )}*/}
                                  {/*</div>*/}
                                  <div className="d-flex flex-row py-4 align-items-center">                                      
                                  </div>
                                  <div className="d-flex flex-row py-4 align-items-center">
                                      <Paginacion totalRecords={totalAct} pageLimit={limite} pageNeighbours={vecindario} onPageChanged={this.onPageChanged} />
                                  </div>

                              </div>
                              <Table responsive borderless>
                                  <thead>
                                      <tr>                                          
                                          <th>#</th>
                                          <th>{this.nombrePorTipo(this.state.tipo)}</th>
                                          <th>A&ntilde;o</th>
                                          {this.usoInstitucion(this.state.tipo) ? <th> Instituci&oacute;n</th> : <></>}
                                          {this.usoTutor(this.state.tipo) ? < th > { this.tutorPorTipo(this.state.tipo) }</th> : <></>}
                                          {this.usoPuesto(this.state.tipo) ? <th> Puesto</th> : <></>}
                                      </tr>
                                  </thead>
                                  <tbody>
                                      {currentActividades.map((act,i) => {
                                          return <tr id={i} key={i}>
                                                    <td>{(i + 1) + (limite * (currentPage-1))}</td>
                                                    <td>{act.nombre} &nbsp;
                                                  {act.registroActividadGestion != null ? <>{act.registroActividadGestion.estado === 'I' ? <Badge color="primary">En revisi&oacute;n</Badge> : act.registroActividadGestion.estado === 'R' ? <Badge color="danger">Rechazado</Badge> : act.registroActividadGestion.estado === 'D' ? <Badge className="icon-pointer" color="warning" onClick={() => this.handleEdit(act.idaexregistroactividad)}>Devuelto</Badge> : <></>}</> : <Badge className="icon-pointer" color="dark" onClick={() => this.handleEdit(act.idaexregistroactividad)}>No registrado</Badge>}
                                                    </td>
                                                    <td>{act.anio}</td>
                                                  {this.usoInstitucion(this.state.tipo) ? <td>{this.state.instituciones.filter(inst => inst.idaexentidad === act.idinstitucion).map(inst => inst.nombre)}</td> : <></>}
                                                  {this.usoTutor(this.state.tipo) ? <td>{act.tutor}</td> : <></>}
                                                  {this.usoPuesto(this.state.tipo) ? <td>{act.puesto}</td> : <></>}
                                                 </tr>
                                      }
                                  /*<text>{act.nombre} - {act.anio} - {act.descripcionevid}</text>*/                                  
                                      )}
                                  </tbody>
                              </Table>
                          </div>
                      </div>
                  </>
              }           
      </div>
    );
    }

    render() {
        
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderActividadesTable(this.state.actividades, this.state.currentActividades, this.state.currentPage, this.state.totalPages);        


        return (
            <div>                
                {contents}                
            </div>
        );
    }

    populateActividades() {
        const user = this.context;        

        fetch(localBack + '/api/RegistroActividad/GetActByTipo/' + this.state.id + '/' + this.state.tipo + '/' + this.state.categoria, {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => {
                this.setState({ status: response.status, });
                return response.json();
            })
            .then(data => {
                /*console.log(data.strMensaje);*/
                if (data.strEstado == 'S') {
                    this.setState({ actividades: data.objDatos, loading: false, total: 1 });
                    /*console.log(this.state.actividades);*/
                } else {
                    this.setState({ actividades: [] });
                }
            });

    }

    populateInfoData() {
        fetch(localBack + '/api/Insignia', {
                method: 'GET',
                /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
            })
                .then(response => response.json())
                .then(data => {
                    /*console.log(data);*/
                    this.setState({
                        categorias: data.objDatos  });
                });

        fetch(localBack + '/api/TipoActividad/GetOnlyActive', {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => response.json())
            .then(data => {
               /* console.log(data);*/
                this.setState({
                    tipos: data.objDatos,
                });
            });

        fetch(localBack + '/api/Entidad', {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => response.json())
            .then(data => {
                /*console.log(data);*/
                this.setState({
                    instituciones: data.objDatos,
                    loading: false
                });
            });
        
    }

    nombrePorTipo(tipo) {
        if (tipo === 1 || tipo === 13 || tipo === 16 || tipo === 25)
            return 'Proyecto'
        else if (tipo === 2 || tipo === 3)
            return 'Reto'
        else if (tipo === 5 || tipo === 8 || tipo === 14 || tipo === 17 || tipo === 19 || tipo === 27 || tipo === 28 || tipo === 29)
            return 'Curso'
        else if (tipo === 20)
            return 'Materia'
        else if (tipo === 21)
            return 'Unidad'
        else if (tipo === 10 || tipo === 12)
            return 'Cargo'
        else if (tipo === 26)
            return 'Deporte'
        else if (tipo === 22)
            return 'Mentoring Edici\u00F3n'
        else if (tipo === 23)
            return 'Torneo'
        else
            return 'Actividad'
    }

    tutorPorTipo(tipo) {
        if (tipo === 22)
            return 'Mentor'
        else
            return 'Tutor'
    }

    usoTutor(tipo) {
        let ids = [1, 22]
        let respuesta = false;
        if (ids.includes(tipo))
            respuesta = true;
        return respuesta;
    }

    usoPuesto(tipo) {
        let puesto = [23];
        let respuesta = false;
        if (puesto.includes(tipo))
            respuesta = true;
        return respuesta;
    }

    usoInstitucion(tipo) {
        let ids = [1, 2, 3, 5, 6, 8, 9, 13, 14, 16, 17, 19, 22, 23, 24, 25, 27, 28, 29];
        let respuesta = false;
        if (ids.includes(tipo))
            respuesta = true;
        return respuesta;
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            /*console.log(tab);*/
            this.setState({
                activeTab: tab
            });
        }
    }

    toggleCard(e) {
        let event = e.target.dataset.event;
        this.setState({ collapse: this.state.collapse === Number(event) ? 0 : Number(event) });
        /*console.log(Number(event));*/        
    }

    toggleDD() {
        this.setState(prevState => ({
            dropdownOpen: !prevState.dropdownOpen
        }));
    }

    newAct() {
        /*console.log('Nueva Actividad');*/
        /*history.push('/Add-Act');*/
    }

    newActEst(categoria, tipo) {
        /*console.log('Nueva Actividad Estudiante');*/
        history.push(homepage+'New-Act/' + categoria + '/' + tipo);
    }

    handleEdit(id) {
        /*console.log("Editar " + id);*/
        history.push(homepage+"Edit-Act/" + id);
        window.location.href = window.location.href;
        /*this.props.history.push("/Edit-Act/" + id);*/
    }

}

LoteActividadesPorTipo.propTypes = {
    /*actividades: PropTypes.array.isRequired,*/
    userId: PropTypes.number.isRequired,
    categoria: PropTypes.number.isRequired,
    tipo: PropTypes.number.isRequired,
};

LoteActividadesPorTipo.contextType = AppContext;
export default LoteActividadesPorTipo;